var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchError)?_c('SensorIssuesErrorView'):(_vm.fetchLoading)?_c('SensorIssuesLoadingView'):(_vm.emptyIssues)?_c('SensorIssuesEmptyView'):_c('SensorIssuesSuccessView')}
var staticRenderFns = []

export { render, staticRenderFns }